<template>
  <div class="storagebill">
    <div class="banner_wrapper">
      <el-breadcrumb separator=">">
        <el-breadcrumb-item>会员功能</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/main/memberredpacket' }" replace>会员红包</el-breadcrumb-item>
        <el-breadcrumb-item>红包账单</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="panel down">
      <div class="panel-header panel-header__auto">
        <el-form :model="form" ref="form">
          <div class="panel-select-group">
            <div class="panel-select__wrapper">
              <span class="panel-select__desc">交易时间</span>
              <el-form-item prop="dateRangeValue">
                <el-date-picker
                  v-model="form.dateRangeValue"
                  type="datetimerange"
                  :editable="false"
                  placeholder="选择日期范围"
                  size="small"
                  :clearable="false">
                </el-date-picker>
              </el-form-item>
            </div>
            <div class="panel-select__wrapper">
              <el-form-item prop="choosetime">
                <el-radio-group v-model="form.choosetime" @change="changeTime">
                  <el-radio-button v-for="item in choosetimes" :label="item.value" :key="item.value">{{ item.name }}</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </div>
          </div>
          <div class="panel-select-group" v-if="!role.single">
            <!-- 门店分组 -->
            <div class="panel-select__wrapper">
              <span class="panel-select__desc">门店分组</span>
              <el-form-item prop="fenzuid">
                <el-select v-model="form.fenzuid" placeholder="全部" size="small" @change="getShopList(form.fenzuid)">
                  <el-option v-for="group in grouplist" :label="group.group_name" :value="group.group_id" :key="group.group_id">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="panel-select__wrapper">
              <span class="panel-select__desc" style="width: 70px;">门店</span>
              <el-form-item prop="selectShopUid">
                <el-select v-model="form.selectShopUid" placeholder="全部" size="small">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="shop in shopData.list" :label="shop.shop_name" :value="shop.uid" :key="shop.uid">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <!--<div class="panel-select-group">
            <div class="panel-select__wrapper">
              <span class="panel-select__desc">红包类型</span>
              <el-form-item prop="checkAll">
                <el-checkbox v-model="form.checkAll" @change="handleCheckAllChange">不限</el-checkbox>
              </el-form-item>
              <el-form-item prop="type">
                <el-checkbox-group v-model="form.type" @change="handleCheckedTypesChange">
                  <el-checkbox v-for="item in typeList" :label="item.value" :key="item.value">{{ item.name }}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </div>
          </div>-->

          <div class="panel-select-group" style="height: 36px">
            <div class="panel-header-btn-group">
              <div class="panel-header-btn" @click="search">
                <span class="el-icon-loading" v-if="loading"></span>
                <span v-else>查询</span>
              </div>
              <div class="panel-header-btn" @click="reset">重置</div>
              <div class="panel-header-btn"><a :href="collectHref" download style="color: #FE9B20; display: block; width: 100%;">导出</a></div>
            </div>
          </div>
        </el-form>
      </div>
      <div class="panel-body">
        <div class="panel-btn-group__wrapper panel-body-btn-group flex-normal">
          <div class="num_total">
            <div class="num_wrapper">
              <p class="num-title">核销金额</p>
              <p class="num-desc">{{ packetData.coupon_amt | formatNumber }} {{ role.currency }}</p>
            </div>
            <div class="num_wrapper">
              <p class="num-title">核销笔数</p>
              <p class="num-desc">{{ packetData.coupon_num || 0 }}</p>
            </div>
          </div>
        </div>
        <el-table
          :data="packetData.ret"
          style="width: 100%"
          row-class-name="el-table__row_fix">
          <el-table-column label="头像" width="70">
            <template slot-scope="scope">
              <img v-if="scope.row.avatar" :src="scope.row.avatar" alt="" />
              <img src="../../assets/img/default.png" v-else />
            </template>
          </el-table-column>
          <el-table-column label="姓名" prop="nickname">
          </el-table-column>
          <el-table-column min-width="100" label="交易时间" prop="sysdtm">
          </el-table-column>
          <el-table-column label="红包金额" min-width="80">
            <template slot-scope="scope">{{ scope.row.amt | formatCurrency }}元</template>
          </el-table-column>
          <el-table-column min-width="100" label="交易门店" prop="shopname">
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination_wrapper" v-if="packetData.total >= 10">
        <el-pagination
          ref="page"
          layout="total, sizes, prev, pager, next, jumper"
          :page-size="pageSize"
          @size-change="handleSizeChange"
          :total="packetData.total"
          @current-change="currentChange"
          :current-page="currentPage">
        </el-pagination>
      </div>
      <div class="table_placeholder" v-else></div>
    </div>

  </div>
</template>

<script>
  import axios from 'axios';
  import config from 'config';
  import qs from 'qs';
  import { formatDate } from '../../common/js/util';
  import Store from '../../common/js/store';

  export default {
    beforeRouteEnter (to, from, next) {
      next((vm) => {
        Object.assign(vm, {
          role: Store.get('role') || {},
          pageSize: 10,
          loading: false,
          currentPage: 1,
          status: false,
          packetData: {},
          grouplist: [],
          shopData: {},
          form: {
            dateRangeValue: [],
            fenzuid: 'all',
            selectShopUid: '',
            choosetime: '1'
          }
        });
        vm.changeTime('1');

        // 门店分组数据
        if (!vm.role.single) {
          vm.getGroupList();
          vm.getShopList();
        }

        vm.getData();

        setTimeout(() => {
          Object.assign(vm, {
            flag: true
          });
        }, 200);
      });
    },

    data() {
      return {
        role: Store.get('role') || {},
        pageSize: 10,
        loading: false,
        currentPage: 1,
        status: false,
        packetData: {},
        grouplist: [],
        shopData: {},
        choosetimes: [
          {'name': '今天', 'value': '1'},
          {'name': '最近一周', 'value': '7'},
          {'name': '最近一个月', 'value': '30'},
          {'name': '最近三个月', 'value': '90'}
        ],
        form: {
          dateRangeValue: [],
          fenzuid: 'all',
          selectShopUid: '',
          choosetime: '1'
        }
      };
    },

    props: {
      shop: {
        type: Object
      }
    },

    computed: {
      collectHref() {
        let collectParmas = Object.assign({}, this.basicParams, {isdownload: true});
        return `${config.host}/merchant/activity/coupon_use/list?${qs.stringify(collectParmas)}`;
      },
      basicParams() {
        let str = 'yyyy-MM-dd HH:mm:ss';

        return {
          starttime: formatDate(this.form.dateRangeValue[0], str),
          endtime: formatDate(this.form.dateRangeValue[1], str),
          fenzu_id: this.form.fenzuid,
          sub_uid: this.form.selectShopUid,
          curpage: this.currentPage - 1,
          length: this.pageSize,
          format: 'cors'
        };
      }
    },
    watch: {
      'form.dateRangeValue': function() {
        if(!this.status) {
          this.form.choosetime = '';
        }
        this.status = false;
      }
    },

    methods: {
      // 分组列表
      getGroupList () {
        axios.get(`${config.host}/merchant/group/list`).then((res) => {
          let data = res.data;
          if(data.respcd === config.code.OK) {
            this.grouplist = data.data;
          } else {
            this.$message.error(data.resperr);
          }
        }).catch(() => {
          this.$message.error('获取门店分组信息失败');
        });
      },

      // 店铺列表
      getShopList (fenzuid) {
        this.form.selectShopUid = '';
        axios.get(`${config.host}/merchant/group/sublist`, {
          params: {
            fenzu_id: fenzuid
          }
        }).then((res) => {
          let data = res.data;
          if(data.respcd === config.code.OK) {
            this.shopData = data.data;
          } else {
            this.$message.error(data.resperr);
          }
        }).catch(() => {
          this.$message.error('获取门店信息失败');
        });
      },

      // 获取数据
      getData() {
        if(!this.loading) {
          this.loading = true;
          axios.get(`${config.host}/merchant/activity/coupon_use/list`, {
            params: this.basicParams
          }).then((res) => {
            this.loading = false;
            let data = res.data;
            if(data.respcd === config.code.OK) {
              this.packetData = data.data;
            } else {
              this.$message.error(data.resperr);
            }
          }).catch(() => {
            this.loading = false;
            this.$message.error('获取数据失败');
          });
        }
      },

      // 页数
      currentChange(current) {
        if (!current && this.currentPage !== 1) {
          this.currentPage = 1;
          return;
        }
        if (current) {
          this.currentPage = current;
        }

        if(this.flag) {
          this.getData();
        }
      },

      // 每页条数
      handleSizeChange(size = 10) {
        this.pageSize = size;
        this.currentChange();
      },

      // 选择时间
      changeTime(value) {
        if(value) {
          this.status = true;
          let end = new Date();
          let start = new Date(end.getTime() - 3600 * 1000 * 24 * (value - 1));

          if(value == 2) {
            end = new Date(end.getTime() - 3600 * 1000 * 24);
          }

          start.setHours(0);
          start.setMinutes(0);
          start.setSeconds(0);

          end.setHours(23);
          end.setMinutes(59);
          end.setSeconds(59);

          this.form.dateRangeValue = [start, end];
        }
      },

      // 点击查询
      search() {
        this.handleSizeChange();
      },

      // 重置表单
      reset() {
        this.status = true;
        this.$refs['form'].resetFields();
        this.changeTime('1');
      }
    }
  };
</script>

<style lang="scss">
  .storagebill {
    .table-title1 {
      font-size: 16px;
    }
    .table-title2 {
      color: #FE9B20;
      font-size: 16px;
    }
    .head-content {
      color: #777a7d;
    }
    .panel-header-btn {
      margin-left: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// packetbill.vue?121dffc0